import React from "react";
import { Banner } from "../common/Banner/Banner";

export const ServiceDetails = () => {

  return (
    <div className="row g-0">
      <div className="col-sm-12 col-md-12 col-lg-12">
        <Banner />
      </div>
    </div>
  );
};
